import { clsx } from '../../../lib/clsx';

import styles from './TextTiny.module.css';

import type { TextProps } from './text.types';

export function TextTiny(props: TextProps) {
  const { lineHeight, color, textAlign, className, style, children, ...rest } = props;

  return (
    <div
      {...rest}
      className={clsx(styles.root, className)}
      style={{
        '--prop-line-height': lineHeight,
        '--prop-color': color,
        ...style,
      }}
      data-text-align={textAlign}
    >
      {children}
    </div>
  );
}
